
import React, { useEffect, useState } from "react";
import { FaShoppingCart, FaHeart, FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

const API_BASE = "https://api.mahal.qa";

const TABS = [
  { key: "Vegetables", labelKey: "cat_vegetables" },
  { key: "Fruits", labelKey: "cat_fruits" },
  { key: "Dairy Products", labelKey: "cat_dairy_products" },
  { key: "Meat & Poultry", labelKey: "cat_meat_poultry" },
  { key: "Grains", labelKey: "cat_grains" },
];

const FreshProducts = () => {
  const [products, setProducts] = useState([]);
  const [activeTab, setActiveTab] = useState(TABS[0].key);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
const isArabic = i18n.language === "ar";

const localizeNumber = (value) => {
  return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US").format(
    Number(value || 0)
  );
};

const localizeCurrency = (value) => {
  return isArabic
    ? `${localizeNumber(value)} ${t("qar")}`
    : `${t("qar")} ${localizeNumber(value)}`;
};

const getProductName = (item) => {
  return isArabic
    ? item.name_ar || item.product_name_arabic || item.name
    : item.name_en || item.product_name_english || item.name;
};

  /* ================= FETCH ================= */
  useEffect(() => {
    fetch(`${API_BASE}/api/gridlist`)
      .then((res) => res.json())
      .then((data) => {
        setProducts(data.products || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ERROR:", err);
        setLoading(false);
      });
  }, []);

  /* ================= FILTER ================= */
  const filteredProducts = products
    .filter((p) => p.category === activeTab)
    .slice(0, 6);

  /* ================= ADD TO CART ================= */
const addToCart = (item) => {

  const token = localStorage.getItem("token");

  if (!token) {
    alert(t("please_login"));
    return;
  }

  axios.post(
    `${API_BASE}/api/cart/add`,
    {
      product_id: item.id,
      quantity: 1,
      price: item.price_numeric,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

  .then((res) => {

    // ✅ Product already exists
    if (res.data.status === "exists") {

alert(t("product_already_cart"));

    }

    // ✅ New product added
    else {

      alert(t("added_to_cart"));

    }

  })

  .catch((err) => {

    console.error("CART ERROR", err);

alert(err.response?.data?.error || t("backend_error"));

  });

};

  /* ================= ADD TO WISHLIST ================= */
  const addToWishlist = (item) => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert(t("please_login"));
      return;
    }

    axios.post(
      `${API_BASE}/api/wishlist/add`,
      {
        product_id: item.id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(() => {
      alert(t("added_to_wishlist"));
    })
    .catch((err) => {
      if (err.response?.status === 409) {
        alert(t("already_in_wishlist"));
      } else {
        console.error("WISHLIST ERROR", err);
        alert(t("wishlist_backend_error"));
      }
    });
  };

  return (
    <section className="fresh_products pt_95 mb-5" dir={isArabic ? "rtl" : "ltr"}>
      <div className="container">

        <div className="text-center mb-4">
          <h2>{t("our_fresh_products")}</h2>
        </div>

        {/* TABS */}
        <div className="mm-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              className={`mm-tab-btn ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {t(tab.labelKey)}
            </button>
          ))}
        </div>

        <div className="row mt-4">

          {loading && <p className="text-center">{t("loading")}</p>}

          {!loading && filteredProducts.length === 0 && (
            <p className="text-center">{t("no_products_found")}</p>
          )}

          {!loading &&
            filteredProducts.map((item) => (
              <div key={item.id} className="col-xl-2 col-lg-3 d-none d-lg-block col-sm-6 mb-4">
                <div className="mm-product-card">

                  <div className="mm-product-img">
                    <img
                    src={
                      item.img1 && item.img1.trim() !== ""
                        ? item.img1.startsWith("http")
                          ? item.img1
                          : `${API_BASE}/${item.img1}`
                        : null
                    }
                    alt={getProductName(item)}
                    onError={(e) => {
                      console.log("Image failed:", item.img1);
                      e.target.style.display = "none";
                    }}
                  />
                  </div>

                  <div className="mm-product-info">
                    <h4>{getProductName(item)}</h4>

<div className="mm-price">
  {localizeCurrency(item.price_numeric)}
</div>

                    <div className="mm-actions">

                      {/* ✅ ADD TO CART */}
                      <button onClick={() => addToCart(item)}>
                        <FaShoppingCart />
                      </button>

                      {/* ✅ WISHLIST */}
                      <button onClick={() => addToWishlist(item)}>
                        <FaHeart />
                      </button>

                      {/* ✅ EYE ICON → SHOPDETAILS */}
                      <Link to={`/shopdetails/${item.id}`}>
                        <FaEye />
                      </Link>

                    </div>

                  </div>

                </div>
              </div>
            ))}

        </div>

      </div>
    </section>
  );
};

export default FreshProducts;